<template lang="pug">
fieldset-section(
  :large="large"
  :flex="flex"
)
  fieldset-input-textarea(
    ref="textarea"
    :wide="wide"
    :name="name"
    :id="name"
    :maxlength="maxlength"
    :placeholder="usePlaceholder ? label : undefined"
    :value="value"
    :prevent-newlines="preventNewlines"
    :error="internalError"
    v-on="$listeners"
  )
  label.fieldset__label(
    v-if="label && !usePlaceholder"
    :for="name"
  ) 
    span {{ label }}

  span.fieldset__error(
    v-if="internalError"
  ) {{ internalError }}

  slot

</template>

<script>
import FieldsetSection from './fieldset-section'
import FieldsetInputTextarea from './fieldset__input--textarea'

export default {
  name: 'fieldset-textarea',
  components: {
    FieldsetSection,
    FieldsetInputTextarea,
  },
  props: {
    flex: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    wide: {
      type: Boolean,
      default: false,
    },
    preventNewlines: {
      type: Boolean,
      default: false,
    },
    usePlaceholder: {
      type: Boolean,
      default: false,
    },
    maxlength: {
      type: Number,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
  },
  watch: {
    value(val) {
      if (val && this.internalError) {
        this.internalError = null
      }
    },
  },
  data() {
    return {
      internalError: null,
    }
  },
  methods: {
    resize() {
      this.$refs.textarea.resize()
    },
    focus() {
      this.$refs.textarea.focus()
    },
    error(message) {
      this.internalError = message
    },
  },
}
</script>

<style lang="sass">
.fieldset__input
  &.--textarea
    min-height: calc((var(--input-fontsize) * var(--input-lineheight)) + (var(--input-padding-v) * 2))
    resize: none
    transition: background-size 0.3s, background-image 0.3s, border-color 0.3s, height 0.3s
</style>
